import { useContext } from 'react';
import {
    AdditionalHourModel,
    EmployeeNodeModel,
    InterruptionModel,
    NewInterruptionModel,
} from '../../../models';
import { AppContext } from '../../context';
import {
    AssociateBusinessUnits,
    AssociateCostCenter,
    BaseConfirmModal,
    CreateAdditionalHoursModal,
    CreateInterruptionsModel,
    DeleteWorkshiftModal,
    DisassociateCostCentersModal,
    DisassociatedBusinessUnitsModal,
    UpdateAndDeleteAdditionalHours,
    UpdateAndDeleteInterruptionModal,
    WorkshiftSchedulingModal,
} from '../modals';
import { FilterInconsistencies } from '../modals/inconsistencies-details/FilterInconsistencies';
import { InconsistenciesDetails } from '../modals/inconsistencies-details/InconsistenciesDetails';
import { DeleteOperationsCenterModal } from '../modals/operations-center/DeleteOperationsCenter';
import { OperationsCenterModal } from '../modals/operations-center/OperationsCenter';
import { AssociateTimeAttendanceEvents } from '../modals/time-attendance-events/associate-time-attendance-events/AssociateTimeAttendanceEvents';
import AssociateMarkingModal from '../modals/time-attendance-events/associate-time-attendance-events/AssociateTimeAttendanceEventsModal';
import ModifyMarkingModal from '../modals/time-attendance-events/modify-time-attendance-events/ModifyTimeAttendanceEventsModal';
import { UpdateTimeAttendanceEvents } from '../modals/time-attendance-events/modify-time-attendance-events/UpdateTimeAttendanceEvents';
import { WorkshiftsSundaysUsualsModal } from '../modals/validate-workshifts-sundays-usual/WorkshiftsSundaysUsualsModal';
import { BonusModal } from '../modals/assign-bonus/BonusModal';
import { AssociateMultipleCostCentersByHourRanges } from '../modals/associate-cost-center/AssociateMultipleCostCentersByHourRanges';
import { CostCenterScheduleResultsModal } from '../modals/associate-cost-center/CostCenterScheduleResultsModal';

interface ModalsWrapperProps {
    deletedWorkshiftScheduling: () => void;
    saveCostCenter: (
        initDate: string,
        lastDate: string,
        employee: EmployeeNodeModel[],
        costCenterId: number
    ) => void;
    saveDisassociatedCostCenters: (costCentersIds: number[]) => void;
    saveBusinessUnits: (
        initDate: string,
        lastDate: string,
        employee: EmployeeNodeModel[],
        businessUnitId: number
    ) => void;
    saveDisassociatedBusinessUnits: (businessUnitsIds: number[]) => void;
    saveWorkshiftsScheduling: (id: number) => void;
    saveInterruption: (body: NewInterruptionModel) => void;
    saveUpdateAndDeleteAddititonalHours: (
        hoursList: InterruptionModel[][],
        isAllDeleted: boolean
    ) => void;
    saveUpdateAndDeleteInterruptions: (
        interruptionList: InterruptionModel[][],
        isAllDeleted: boolean
    ) => void;
    saveAdditionalHours: (
        hoursList: AdditionalHourModel[],
        employees: EmployeeNodeModel[],
        initDate: string,
        lastDate: string
    ) => void;
    saveAssociateMarking: (data: AssociateTimeAttendanceEvents) => void;
    saveModifyMarking: (data: UpdateTimeAttendanceEvents[]) => void;
    selectedEmployees: EmployeeNodeModel[];
    saveBonusAssignments: (
        bonusRuleIds: number[],
        startDate: string | number | undefined,
        endDate: string | number | undefined,
        employees: EmployeeNodeModel[]
    ) => void;
    saveAssingOperationsCenter: (
        initDate: string,
        lastDate: string,
        employeeIds: (string | number)[],
        operationCenterId: number
    ) => void;
    saveADeleteOperationsCenter: (ids: number[]) => void;
    saveWorkshiftsSundaysUsuals: (
        initDate: string,
        finishDate: string,
        employeeIds: number[]
    ) => void;
    saveMultipleCostCentersByHourRanges: (data: {
        startDate: string;
        endDate: string;
        employees: Array<{
            employeeId: number;
            isBulkAssignment: boolean;
            costCenters: Array<{
                costCenterId: number;
                costCenterName: string;
                date: string;
                startTime: string;
                endTime: string;
                schedulingCostCenterId: number;
                workshiftSchedulingId: number;
            }>;
        }>;
        costCenterIdsToRemove: number[];
    }) => void;
}

export const ModalsWrapper = ({
    deletedWorkshiftScheduling,
    saveAdditionalHours,
    saveBusinessUnits,
    saveCostCenter,
    saveDisassociatedBusinessUnits,
    saveDisassociatedCostCenters,
    saveInterruption,
    saveUpdateAndDeleteAddititonalHours,
    saveUpdateAndDeleteInterruptions,
    saveWorkshiftsScheduling,
    saveAssociateMarking,
    saveBonusAssignments,
    saveModifyMarking,
    selectedEmployees,
    saveADeleteOperationsCenter,
    saveAssingOperationsCenter,
    saveWorkshiftsSundaysUsuals,
    saveMultipleCostCentersByHourRanges,
}: ModalsWrapperProps) => {
    const {
        isOpenAdditionalHoursModal,
        isOpenBusinessUnitsModal,
        isOpenCostCenterModal,
        isOpenCreateInterruptionModal,
        isOpenDeleteWorkshiftModal,
        isOpenUpdateAndDeleteAdditionalHoursModal,
        isOpenUpdateAndDeleteModal,
        isOpenWorkshiftModal,
        isOpenBonusModal,
        isOpenDisassociatedBusinessUnitsModal,
        isOpenDisassociatedCostCenterModal,
        modalInfoWorkshift,
        modalAssociateBusinessUnits,
        modalAssociateCostCenter,
        modalDisassociateBusinessUnits,
        modalDisassociateCostCenter,
        modalInfoInterruption,
        modalUpdatedAndDeleteAdditionalHours,
        modalUpdatedAndDeleteInfo,
        modalAddtionalInfo,
        modalInfoBonus,
        setModalInfoWorkshift,
        setIsOpenCreateInterruptionModal,
        setIsOpenAdditionalHoursModal,
        setIsOpenBonusModal,
        setOpenAlertModal,
        setIsOpenDeleteWorkshiftModal,
        setIsOpenDisassociatedBusinessUnitsModal,
        setIsOpenBusinessUnitsModal,
        setIsOpenCostCenterModal,
        setIsOpenDisassociatedCostCenterModal,
        setIsOpenUpdateAndDeleteModal,
        setIsOpenUpdateAndDeleteAdditionalHoursModal,
        openAlertModal,
        isOpenCreateMarkingModal,
        isOpenModifyMarkingModal,
        setIsOpenCreateMarkingModal,
        setIsOpenModifyMarkingModal,
        modalCreateMarking,
        modalModifyMarking,
        isOpenMultipleCostCentersByHourRangesModal,
        setIsOpenMultipleCostCentersByHourRangesModal,
        modalInfoMultipleCostCentersByHourRanges,
        isOpenCostCenterScheduleResultsModal,
        setIsOpenCostCenterScheduleResultsModal,
        costCenterScheduleResults,
        detailsInconsistenciesModal,
        isOpenDetailsInconsistenciesModal,
        setIsOpenDetailsInconsistenciesModal,
        isOpenInconsistenciesModal,
        setIsOpenInconsistenciesModal,
        inconsistenciesModal,
        isOpenOperationsCenterModal,
        isDeleteOperationsCenterModal,
        isOpenWorkshiftsSundaysUsualsModal,
        workshiftsSundaysUsualsModal,
        setIsOpenWorkshiftsSundaysUsualsModal,
        workshiftShedulingList
    } = useContext(AppContext);

    return (
        <>
            {isOpenDeleteWorkshiftModal && (
                <DeleteWorkshiftModal
                    startDate={modalInfoWorkshift?.startDate}
                    endDate={modalInfoWorkshift?.endDate}
                    employee={modalInfoWorkshift?.employee}
                    isOpen={isOpenDeleteWorkshiftModal}
                    setModalOpen={setIsOpenDeleteWorkshiftModal}
                    deleteWorkshiftsScheduling={deletedWorkshiftScheduling}
                />
            )}

            {isOpenCostCenterModal && (
                <AssociateCostCenter
                    isOpen={isOpenCostCenterModal}
                    onClose={setIsOpenCostCenterModal}
                    onSubmit={saveCostCenter}
                    startDate={modalAssociateCostCenter.startDate}
                    endDate={modalAssociateCostCenter.endDate}
                    employee={modalAssociateCostCenter.employee}
                    group={modalAssociateCostCenter.parentNodeSelected}
                />
            )}

            {isOpenDisassociatedCostCenterModal && (
                <DisassociateCostCentersModal
                    isOpen={isOpenDisassociatedCostCenterModal}
                    onClose={setIsOpenDisassociatedCostCenterModal}
                    onSubmit={saveDisassociatedCostCenters}
                    startDate={modalDisassociateCostCenter.startDate}
                    endDate={modalDisassociateCostCenter.endDate}
                    employee={modalDisassociateCostCenter.employee}
                    listToDelete={modalDisassociateCostCenter.listToDelete}
                />
            )}

            {isOpenBusinessUnitsModal && (
                <AssociateBusinessUnits
                    isOpen={isOpenBusinessUnitsModal}
                    onClose={setIsOpenBusinessUnitsModal}
                    onSubmit={saveBusinessUnits}
                    startDate={modalAssociateBusinessUnits.startDate}
                    endDate={modalAssociateBusinessUnits.endDate}
                    employee={modalAssociateBusinessUnits.employee}
                />
            )}

            {isOpenDisassociatedBusinessUnitsModal && (
                <DisassociatedBusinessUnitsModal
                    isOpen={isOpenDisassociatedBusinessUnitsModal}
                    onClose={setIsOpenDisassociatedBusinessUnitsModal}
                    onSubmit={saveDisassociatedBusinessUnits}
                    startDate={modalDisassociateBusinessUnits.startDate}
                    endDate={modalDisassociateBusinessUnits.endDate}
                    employee={modalDisassociateBusinessUnits.employee}
                    listToDelete={modalDisassociateBusinessUnits.listToDelete}
                />
            )}

            {isOpenWorkshiftModal && (
                <WorkshiftSchedulingModal
                    isOpen={isOpenWorkshiftModal}
                    saveWorkshiftsScheduling={saveWorkshiftsScheduling}
                />
            )}

            {isOpenDetailsInconsistenciesModal && (
                <InconsistenciesDetails
                    startDate={detailsInconsistenciesModal?.startDate}
                    endDate={detailsInconsistenciesModal?.endDate}
                    employee={detailsInconsistenciesModal?.employee}
                    inconsistencies={detailsInconsistenciesModal?.inconsistencies}
                    isOpen={isOpenDetailsInconsistenciesModal}
                    setModalOpen={setIsOpenDetailsInconsistenciesModal}
                    treeEmployee={selectedEmployees}
                />
            )}

            {isOpenWorkshiftsSundaysUsualsModal && (
                <WorkshiftsSundaysUsualsModal
                    employee={workshiftsSundaysUsualsModal?.employee}
                    endDate={workshiftsSundaysUsualsModal?.endDate}
                    isOpen={isOpenWorkshiftsSundaysUsualsModal}
                    setModalOpen={setIsOpenWorkshiftsSundaysUsualsModal}
                    startDate={workshiftsSundaysUsualsModal?.startDate}
                    saveSubmit={saveWorkshiftsSundaysUsuals}
                />
            )}

            {isOpenInconsistenciesModal && (
                <FilterInconsistencies
                    employee={inconsistenciesModal?.employee}
                    endDate={inconsistenciesModal?.endDate}
                    isOpen={isOpenInconsistenciesModal}
                    setModalOpen={setIsOpenInconsistenciesModal}
                    startDate={inconsistenciesModal?.startDate}
                />
            )}

            {isOpenCreateMarkingModal && (
                <AssociateMarkingModal
                    startDate={modalCreateMarking?.startDate}
                    endDate={modalCreateMarking?.endDate}
                    employee={modalCreateMarking?.employee}
                    workshifts={modalCreateMarking?.workshifts}
                    isOpen={isOpenCreateMarkingModal}
                    setModalOpen={setIsOpenCreateMarkingModal}
                    saveTimeAttendanceEvents={saveAssociateMarking}
                />
            )}

            {isOpenModifyMarkingModal && (
                <ModifyMarkingModal
                    startDate={modalModifyMarking?.startDate}
                    endDate={modalModifyMarking?.endDate}
                    employee={modalModifyMarking?.employee}
                    workshifts={modalModifyMarking?.workshifts}
                    isOpen={isOpenModifyMarkingModal}
                    setModalOpen={setIsOpenModifyMarkingModal}
                    saveTimeAttendanceEvents={saveModifyMarking}
                />
            )}

            {isOpenCreateInterruptionModal && (
                <CreateInterruptionsModel
                    startDate={modalInfoInterruption?.startDate}
                    endDate={modalInfoInterruption?.endDate}
                    employee={modalInfoInterruption?.employee}
                    workshifts={modalInfoInterruption?.workshifts}
                    isOpen={isOpenCreateInterruptionModal}
                    setModalOpen={setIsOpenCreateInterruptionModal}
                    saveInterruption={saveInterruption}
                />
            )}

            {isOpenBonusModal && (
                <BonusModal
                    isOpen={isOpenBonusModal}
                    onClose={() => setIsOpenBonusModal(false)}
                    startDate={modalInfoBonus.startDate}
                    endDate={modalInfoBonus.endDate}
                    employee={modalInfoBonus.employee}
                    saveBonusAssignments={saveBonusAssignments}
                />
            )}

            {isOpenUpdateAndDeleteAdditionalHoursModal && (
                <UpdateAndDeleteAdditionalHours
                    employee={modalUpdatedAndDeleteAdditionalHours.employee}
                    initDate={modalUpdatedAndDeleteAdditionalHours.initDate}
                    lastDate={modalUpdatedAndDeleteAdditionalHours.lastDate}
                    additionals={modalUpdatedAndDeleteAdditionalHours.additionals}
                    isOpen={isOpenUpdateAndDeleteAdditionalHoursModal}
                    saveChanges={saveUpdateAndDeleteAddititonalHours}
                    setModalOpen={setIsOpenUpdateAndDeleteAdditionalHoursModal}
                />
            )}

            {isOpenUpdateAndDeleteModal && (
                <UpdateAndDeleteInterruptionModal
                    startDate={modalUpdatedAndDeleteInfo.startDate}
                    endDate={modalUpdatedAndDeleteInfo.endDate}
                    employee={modalUpdatedAndDeleteInfo.employee}
                    interruption={modalUpdatedAndDeleteInfo.interruption}
                    isOpen={isOpenUpdateAndDeleteModal}
                    setModalOpen={setIsOpenUpdateAndDeleteModal}
                    saveUpdateAndDeleteInterruptions={
                        saveUpdateAndDeleteInterruptions
                    }
                />
            )}

            {isOpenAdditionalHoursModal && (
                <CreateAdditionalHoursModal
                    isOpen={isOpenAdditionalHoursModal}
                    startDate={modalAddtionalInfo.startDate}
                    endDate={modalAddtionalInfo.endDate}
                    employee={modalAddtionalInfo.employee}
                    saveAdditionalHours={saveAdditionalHours}
                    setModalOpen={setIsOpenAdditionalHoursModal}
                />
            )}

            {isOpenOperationsCenterModal && (
                <OperationsCenterModal
                    isOpen={isOpenOperationsCenterModal}
                    save={saveAssingOperationsCenter}
                />
            )}

            {isDeleteOperationsCenterModal && (
                <DeleteOperationsCenterModal
                    isOpen={isDeleteOperationsCenterModal}
                    save={saveADeleteOperationsCenter}
                />
            )}

            {openAlertModal.isOpen && (
                <BaseConfirmModal
                    isLoading={false}
                    onClose={() => {
                        setOpenAlertModal({
                            isOpen: false,
                            message: '',
                            value: '',
                        });
                    }}
                    onSubmit={() => {
                        setOpenAlertModal({
                            isOpen: false,
                            message: '',
                            value: '',
                        });
                    }}
                    modalTitle={``}
                    isOpen={openAlertModal.isOpen}
                    isShowControls={true}
                >
                    <div className='modal-body text-dark'>
                        <h3 className='text-center mb-5 text-dark modal-title'>
                            {openAlertModal.message} {openAlertModal.value}
                        </h3>
                    </div>
                </BaseConfirmModal>
            )}

            {isOpenMultipleCostCentersByHourRangesModal && (
                <AssociateMultipleCostCentersByHourRanges
                    isOpen={isOpenMultipleCostCentersByHourRangesModal}
                    onClose={() => setIsOpenMultipleCostCentersByHourRangesModal(false)}
                    onSubmit={saveMultipleCostCentersByHourRanges}
                    startDate={modalInfoMultipleCostCentersByHourRanges?.startDate}
                    endDate={modalInfoMultipleCostCentersByHourRanges?.endDate}
                    employee={modalInfoMultipleCostCentersByHourRanges?.employee}
                    group={modalInfoMultipleCostCentersByHourRanges?.parentNodeSelected || []}
                    costCenters={modalInfoMultipleCostCentersByHourRanges?.costCenters || []}
                    workshiftShedulingList={workshiftShedulingList}
                />
            )}

            {isOpenCostCenterScheduleResultsModal && (
                <CostCenterScheduleResultsModal
                    isOpen={isOpenCostCenterScheduleResultsModal}
                    onClose={setIsOpenCostCenterScheduleResultsModal}
                    acceptedResults={costCenterScheduleResults.acceptedCostCenterSchedules || []}
                    rejectedResults={costCenterScheduleResults.rejectionOfCostCenterSchedules || []}
                />
            )}
        </>
    );
};
